import React from 'react'

import {
  Card,
  Typography,
  Grid,
  Box,
  Divider,
  IconButton,
} from '@material-ui/core'
import { useHistory, useRouteMatch } from 'react-router-dom'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import { useDispatch } from 'react-redux'
import styles from '../settingsStyles'
import PageLink from '../components/PageLink'
import AppVersion from '../components/AppVersion'
import { trackEvent } from '../../../helpers/analytics'

function AppInfo() {
  const classes = styles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { path } = useRouteMatch()

  const handleLinkPress = (link) => {
    history.push(`${path}${link}`)
  }

  return (
    <Box className={classes.centerPage}>
      <Grid
        container
        direction="column"
        alignItems="center"
        className={classes.container}
        wrap="nowrap"
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.sectionTitle}
        >
          <IconButton
            onClick={() => {
              trackEvent(dispatch, {
                eventName: 'uxp_settings_item_click',
                module: 'Settings',
                object: 'BackButton',
                action: 'Click',
                actionContext: 'AppInfo',
                actionContextValue: 'BackButton',
              })
              history.replace('/settings')
            }}
            aria-label="Back"
            className={classes.backButton}
          >
            <ArrowBackIos />
          </IconButton>
          <Typography variant="h1">
            <b>App Info</b>
          </Typography>
        </Grid>
        <Grid item className={classes.fullWidth}>
          <Card className={classes.linksCard}>
            <AppVersion
              versionNumber="1.4.170"
              whatsNewDescription="Widget updates, bug fixes"
            />
            <Divider variant="middle" className={classes.fullWidth} />
            <PageLink
              title="Copyright Information"
              link={() => handleLinkPress('/copyrights')}
              path="/copyrights"
              section="AppInfo"
            />
            <Divider variant="middle" className={classes.fullWidth} />
            <PageLink
              title="Privacy Notices"
              link={() => handleLinkPress('/privacyNotices')}
              path="/privacyNotices"
              section="AppInfo"
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AppInfo
